// Stylesheets
import './assets/scss/site.scss';

import { hover } from './assets/modules/hover';
import { externalLink } from './assets/modules/externalLink';
import { countdown } from './assets/modules/countdown';
import { time } from './assets/modules/time';
import { trigger } from './assets/modules/trigger';
import { exhibitors } from './assets/modules/exhibitors';
import { swiperCarousel } from './assets/modules/swiperCarousel';
import { fluidvideo } from './assets/modules/fluidvideo';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe-init';
import { limitTextarea } from './assets/modules/limitTextarea';
import { copyUrl } from './assets/modules/copyUrl';
import { inputFileStyle } from './assets/modules/inputFileStyle';
import { inputSelectStyle } from './assets/modules/inputSelectStyle';
import { inputRadioStyle } from './assets/modules/inputRadioStyle';
import { pushStateHandler } from './assets/modules/pushState';
import { slideShow } from './assets/modules/slideshow';

const init = () => {
  hover();
  trigger();
  externalLink();
  countdown();
  time();
  exhibitors();
  swiperCarousel();
  fluidvideo();
  initPhotoSwipeFromDOM('.js-pswp-container');
  limitTextarea();
  copyUrl();
  inputFileStyle();
  inputSelectStyle();
  inputRadioStyle();
  pushStateHandler();
  slideShow();
  document.body.classList.add('is-init')
}

init();